import axios from '@/plugins/axiosV2'

const http = axios(process.env.VUE_APP_API_TICKETS);

export default {
  obtener_area() {
    return http.get(`/miarea`);
  }
}